import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopToqueRetalNavigation: FC = () => {
  return (
    <>
      <IfopNavigation
        title="Pesquisa Datafolha | O câncer da próstata e o exame de toque retal no Brasil"
        links={[
          {
            to: '/exame-de-toque-retal/',
            content: (
              <HStack>
                <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="3rem" width="3rem" />
                <span>Ver o relatório</span>
              </HStack>
            )
          },
          {
            to: '/pesquisa-exame-de-toque-retal/',
            content: (
              <HStack>
                <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="3rem" width="3rem" />
                <span>Ver a pesquisa completa</span>
              </HStack>
            )
          }
        ]}
      />
    </>
  )
}

export default IfopToqueRetalNavigation
